import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DesignService {
  headerStyle: string;
  footerStyle: string;
  public showCreatePopup: boolean = false;
  pollPageNo: number = 1;
  trendingPageNo: number = 1;
  lastClickedId: any = null;

  headerStyleChange: Subject<string> = new Subject<string>();
  footerStyleChange: Subject<string> = new Subject<string>();

  private subject = new Subject<any>();

  constructor() {
    this.headerStyle = 'homepage';
    this.footerStyle = 'homepage';
  }

  sendClickEvent(data?: any) {
    this.subject.next(data ? data : 'Button Clicked');
  }
  getClickEvent(): Observable<any> {
    return this.subject.asObservable();
  }

  getHeaderStyle() {
    return this.headerStyle;
  }

  getFooterStyle() {
    return this.footerStyle;
  }

  setHeaderStyle(type: any) {
    // alert("demo...."+ type);
    if (this.headerStyle !== type) {
      this.headerStyle = type;
      this.headerStyleChange.next(this.headerStyle);
      this.setFooterStyle(type);
    }
  }

  setFooterStyle(type: any) {
    if (this.footerStyle !== type) {
      this.footerStyle = type;
      this.footerStyleChange.next(this.footerStyle);
    }
  }
}
